import React, { Component } from "react";
import axios from "axios";
// import { CiLock } from "react-icons/ci";
import { FaRegSadTear } from "react-icons/fa";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { IoMdUnlock } from "react-icons/io";
import { IoMdLock } from "react-icons/io";


class CourseProcedure extends Component {
    state = {
        course: [],
        status: '',
        parsedDescriptions: [],
        collapsedStepIds: {},
    }

    componentDidMount() {
        this.setState({ course: this.props.course });
        const parsedDescriptions = {}; // Initialize an object to store parsed descriptions

        if (this.props.course?.step_by_step) {
            this.props.course.step_by_step.forEach(step => {
                if (step.description) {
                    parsedDescriptions[step.id] = this.parseDescription(step.description); // Store parsed descriptions by step ID
                }
            });
        }

        this.setState({ parsedDescriptions: parsedDescriptions });
    }

    componentDidUpdate(prevProps) {
        if (this.props.course !== prevProps.course) {
            this.setState({ course: this.props.course });
            const parsedDescriptions = {}; // Initialize an object to store parsed descriptions

            if (this.props.course?.step_by_step) {
                this.props.course.step_by_step.forEach(step => {
                    if (step.description) {
                        parsedDescriptions[step.id] = this.parseDescription(step.description); // Store parsed descriptions by step ID
                    }
                });
            }

            this.setState({ parsedDescriptions: parsedDescriptions });
        }
    }

    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");


    //     try {
    //         const course_id = this.props.course_id
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //         if (accessToken) {
    //             headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //             };
    //         }

    //         const response = await axios.get("https://api.geoinfoacademy.com/api/courses/" + courseId, {
    //             headers: headers,
    //         });
    //         this.setState({ course: response.data });
    //         const parsedDescriptions = {}; // Initialize an object to store parsed descriptions
    //         response.data.step_by_step.forEach(step => {
    //             if (step.description) {
    //                 parsedDescriptions[step.id] = this.parseDescription(step.description); // Store parsed descriptions by step ID
    //             }
    //         });
    //         this.setState({ parsedDescriptions: parsedDescriptions });

    //         console.log("API Response:", response.data);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };
    parseDescription = (text) => {
        if (!text) {
            return [];
        }

        const lines = text.split('\n');
        return lines
            .filter((line) => line.trim().startsWith('#'))
            .map((line, index) => {
                const trimmedLine = line.trim().substring(1).trim();
                return {
                    id: (index + 1).toString(),
                    paragraph: trimmedLine,
                };
            });
    };



    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in

            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/interested-courses/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                window.location.href = `/description/${course_id}/paymentverify`;
            }
            catch (error) {
                console.error("Error initiating payment:", error);
            }

        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }
    };





    toggleDescription = (stepId) => {
        this.setState((prevState) => ({
            collapsedStepIds: {
                ...prevState.collapsedStepIds,
                [stepId]: !prevState.collapsedStepIds[stepId],
            },
        }));
    };



    render() {
        console.log("checking procedure", this.state.procedure)
        const procedure = this.state.course
        const steps =
            procedure?.step_by_step?.length ? (
                procedure.step_by_step.map((step) => {
                    console.log("Step Description:", step.description); // Log the description

                    return (
                        <div className="course_procedure_cover" key={step.id}>
                            <div className="course_content_head">
                                <h4>{step.title}</h4>
                                <button onClick={() => this.toggleDescription(step.id)}>
                                    {this.state.collapsedStepIds[step.id] ? <FaAngleDown /> : <FaAngleUp />}
                                </button>
                            </div>

                            <div
                                className="description-container"
                                style={{
                                    display: this.state.collapsedStepIds[step.id] ? 'none' : 'block',
                                }}
                            >
                                {this.state.parsedDescriptions[step.id] && this.state.parsedDescriptions[step.id].map(paragraphObj => (
                                    <li key={paragraphObj.id}>
                                        {procedure.enrolled ? <IoMdUnlock /> : <IoMdLock />}
                                        <p>
                                            {paragraphObj.paragraph}
                                        </p>
                                    </li>
                                ))}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="enroll_error">
                    <div className="enroll_cover">
                        <FaRegSadTear />
                        <p>The Course doesn't come with description</p>
                    </div>
                </div>
            );
        return (
            <section className="course_procedure">
                <h3>Course Contents</h3>
                <div className="cover">
                    {/* {this.state.course.enrolled !== true ?
                        <div className="enroll_error">
                            <div className="enroll_cover">
                                <CiLock />
                                <p>Enroll For Course To Gain Access</p>
                                <button onClick={this.handleRedirect}>Apply For Course</button>
                            </div>
                        </div>

                        : */}
                    {steps}
                    {/* } */}
                </div>
            </section>
        )
    }
}


export default CourseProcedure